import React from "react";
import googlePlay from "./Assets/5e9c636db27cf63cad9dabff_Google play badge.png";
import appStore from "./Assets/5e9c636d9ba599ed1b02e664_Play store badge (1).png";
import { useMediaQuery } from "react-responsive";
import jsonp from "jsonp";

function Subscribe() {
  const isDesktopOrLaptop = useMediaQuery({
    query: "(max-device-width: 1440px)",
  });
  const isLaptopOrTablet = useMediaQuery({
    query: "(max-device-width: 1024px)",
  });
  const largeTablet = useMediaQuery({ query: "(min-device-width: 768px)" });
  const isPhoneOrTablet = useMediaQuery({
    query: "(max-device-width: 500px)",
  });
  const phone = useMediaQuery({ query: "(max-device-width: 320px)" });

  const subscribeContainer = {
    width: "60%",
  };

  const formForm = {
    //    width: '55%',
    display: "inline-block",
  };

  const emailHolder = {
    width: "460px",
  };

  const submitButton = {
    width: "465px",
    cursor: "Pointer",
    border: "none",
    marginBottom: "40px",
    display: "block",
  };

  const thankYouButton = {
    display: "none",
    backgroundColor: "#55b559",
    color: "white",
    padding: "5%",
    width: "100%",
    borderRadius: "8px",
  };

  if (isDesktopOrLaptop) {
    // formForm.width = '50%'
    formForm.display = "inline-block";
  }
  if (isLaptopOrTablet) {
    // formForm.width = '65%'
    formForm.display = "inline-block";
  }
  if (largeTablet) {
    // formForm.width = '40%'
    formForm.display = "inline-block";
  }
  if (isLaptopOrTablet) {
    // formForm.width='65%'
    formForm.display = "inline-block";
    emailHolder.width = "300px";
    submitButton.width = "100%";
  }
  if (isPhoneOrTablet) {
    // formForm.width = '65%'
    formForm.display = "inline-block";
    subscribeContainer.width = "80%";
    submitButton.cursor = "Pointer";
    thankYouButton.width = "90%";
  }
  if (phone) {
    emailHolder.width = "300px";
    submitButton.width = "300px";
    // formForm.width = '95%'
    formForm.display = "inline-block";
    subscribeContainer.width = "90%";
    thankYouButton.width = "90%";
  }

  function handleSubmit(event) {
    event.preventDefault();

    console.log("test");
    const action =
      "https://phenon.us4.list-manage.com/subscribe/post?u=b841078c108fd42216ca9639a&amp;id=2f4243924f";

    const fields = [
      {
        name: "EMAIL",
        placeholder: "Email",
        type: "email",
        required: true,
      },
    ];

    const email = document.getElementById("email").value;

    const values = fields
      .map((field) => {
        return `${field.name}=${encodeURIComponent(email)}`;
      })
      .join("&");

    const path = `${action}&${values}`;
    const url = path.replace("/post?", "/post-json?");
    sendData(url);
  }

  function sendData(url) {
    jsonp(url, { param: "c" }, (err, data) => {
      if (data.msg.includes("already subscribed")) {
        // this.setState({ status: "duplicate" });
        console.log("alr sub");
      } else if (err) {
        // this.setState({ status: "error" });
        console.log("err");
      } else if (data.result !== "success") {
        // this.setState({ status: "error" });
        console.log("successs");
      } else {
        // this.setState({ status: "success" });
        console.log("successs");
      }
    });
  }

  function handleClick() {
    document.getElementsByClassName("submitButton")[0].style.display = "none";
    document.getElementById("email").style.display = "none";
    document.getElementById("thankYou").style.display = "block";

    // innerHTML =
    //     "Thank you! Your submission has been received!");
    // EmailInput.style.cssText = "background-color: green; color: white";
  }

  return (
    <div>
      <div className="SubscriptionContainer" style={subscribeContainer}>
        <h2 id="subscribe-heading">Subscribe & stay tuned</h2>

        <form
          id="email-form"
          name="email"
          data-name="Email Form"
          // method="GET"
          // action="https://phenon.us4.list-manage.com/subscribe/post-json"
          className="subscribe-form-flex"
          style={formForm}
          onSubmit={handleSubmit}
        >
          <input
            type="email"
            placeholder="Enter your email"
            maxLength="256"
            id="email"
            name="EMAIL"
            required
            style={emailHolder}
          ></input>
          <input
            name="u"
            value="b841078c108fd42216ca9639a"
            type="hidden"
          ></input>
          <input name="id" value="2f4243924f" type="hidden"></input>

          <input
            type="submit"
            value="Subscribe"
            className="submitButton"
            data-wait="Please wait..."
            style={submitButton}
            onClick={handleClick}
          ></input>
          <p id="thankYou" style={thankYouButton}>
            Thank you! Your submission has been received!
          </p>
        </form>

        <p id="paragraph2">
          The data you provide may be subject to our personal data policy. In
          such a case we will treat it in accordance with the EU General Data
          Protection Regulation. By submitting this form, we assume that you
          have given us your consent to forward you our news about the Phenon
          Tech project and you are aware of personal data policy rights arising
          from GDPR. You can exercise your right to be forgotten by Phenon Tech.
          Should you no longer wish to hear from us, unsubscribe at any time.
        </p>
        <a
          href="https://apps.apple.com/us/app/tracker-by-phenon/id1497464162?ls=1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={appStore} className="appStore" alt="app-store" />
        </a>
        <a
          href="https://play.google.com/store/apps/details?id=io.phenon.tracker"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src={googlePlay} className="googlePlay" alt="google-play" />
        </a>
      </div>
    </div>
  );
}

export default Subscribe;
